import user from './user'
import organization from './organization'
import home from './home'
import order from './order'
import system from './system'

export default {
  user,
  organization,
  home,
  order,
  system
}
